import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, ButtonBlock, Loader } from '../../../atoms';
import { setDeactivateCardType, setHotlistApiSuccess } from '../../../redux/user/actions';
import api from '../../../services/api';
import { formatDecimalWithCurrency } from '../../../services/utils';
import './Deactivate0.scss';

const Deactivate0 = ({ toNextStep, fields, userInfo }) => {
  const visibleId = userInfo.selectedCard.visibleId;
  const mediaId = userInfo.selectedCard.mediaId;
  const nickname = userInfo.selectedCard.nickName;
  let fareMedias = useSelector((reduxState) => reduxState.user.fareMedias);
  fareMedias =
    fareMedias && fareMedias.length > 0 && fareMedias.find((data) => data.visibleId === visibleId);
  const currentBalance = fareMedias?.currentBalance;
  const customerId = useSelector((reduxState) => reduxState.user.customerId);
  const transitPasses =
    fareMedias && fareMedias?.passes && fareMedias?.passes.length > 0 && fareMedias?.passes;
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    // window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);
  const getUserInfoApi = () => {
    setIsLoading(true);
    api
      .getUserInfo()
      .then((response) => {
        deactivateCardApi(response.data);
      })
      .catch(() => {
        //console.log('error');
        deactivateCardApi();
      });
  };
  const deactivateCardApi = (data) => {
    api
      .createHotListMedia({
        customerId: customerId,
        mediaId: mediaId,
        visibleId: visibleId,
        IsStubEnabled: true,
        IsErrorFlowEnabled: false,
      })
      .then((response) => {
        if (response?.data?.Success) {
          dispatch(setHotlistApiSuccess({ hotlistApiSuccess: true, data }));
        } else {
          dispatch(setHotlistApiSuccess({ hotlistApiSuccess: false }));
        }
        setIsLoading(false);
        toNextStep();
      })
      .catch(() => {
        dispatch(setHotlistApiSuccess({ hotlistApiSuccess: false }));
        setIsLoading(false);
        toNextStep();
        //console.log('error');
      });
  };
  let formattedBalance = formatDecimalWithCurrency(currentBalance);
  return (
    <>
      {isLoading && <Loader />}
      <div className="deactivate-card-withButton">
        <div className="deactivate-card-section">
          <div className="card-header">
            <Text field={fields.CardToDeactivate} />
          </div>
          <div className="card-content">
            <div className="card-Number">
              <RichText field={fields.PrestoCardNumberLable} />
              <span>
                <b>{visibleId}</b>
              </span>
            </div>
            <div className="card-nick-name">
              <RichText field={fields.CardNickNameLable} />
              <span>
                <b>{nickname}</b>
              </span>
            </div>
            <div className="card-balance">
              <RichText field={fields.BalanceLabel} />
              <span>
                <b>{formattedBalance}</b>
              </span>
            </div>

            <div className="card-transitPass">
              <RichText field={fields.TransitPassLabel} />
              {transitPasses && transitPasses.length > 0 ? (
                <div>
                  {transitPasses.map((pass) => {
                    if (pass.ProductName !== null) {
                      return <p className="transitpass-list-RLC">{pass.ProductName}</p>;
                    }
                  })}
                </div>
              ) : (
                '-'
              )}
            </div>
          </div>
        </div>
        <div className="deactivate-card-disclaimer">
          <RichText field={fields.DeactivateCardDisclaimer} />
        </div>
        <ButtonBlock className="Deactivated-Button">
          <Button
            type="submit"
            buttonTextA11y=""
            onClick={() => {
              getUserInfoApi();
            }}
          >
            <Text field={fields.ConfirmCTALabel} />
          </Button>
          <Button
            type="submit"
            buttonTextA11y=""
            onClick={() => dispatch(setDeactivateCardType(''))}
          >
            <Text field={fields.GoBackCTALabel} />
          </Button>
        </ButtonBlock>
      </div>
    </>
  );
};

export default Deactivate0;
